import { defineMessages } from 'react-intl';

export default defineMessages({
  greeting: {
    id: 'component.chatplugin.facebook.greeting',
    defaultMessage: 'Hello! How can we help you?',
  },
});
